<template>
  <div class="container_box commodityStickerOperation_box">
    <!--头部区域-->
    <div class="scanning_header_box flex justify-content-between align-items-center mb10">
      <h2 class="title">{{ $t('key1003985') }}</h2>
      <Button type="primary" @click="endLabelingBtn" v-if="getPermission('ymsContainerStatus_endChangeOrder')">{{ $t('key1003986') }}</Button>
    </div>
    <!--扫描区域-->
    <div class="scanning_box mb10">
      <div class="input_styles flex flex-direction">
        <h4 class="title">{{ $t('key1000586') }}</h4>
        <Input
          size="large"
          :disabled="!getPermission('ymsContainerGoodsCheck_appendYmsExpressBill')"
          :element-id="'scanning'"
          :placeholder="$t('key1003983')"
          @on-enter="enterScanInput"
          prefix="icon-scan"
          clearable
          v-model.trim="supplierSku">
        </Input>
      </div>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box mb10" style="padding: 12px 30px;">
      <!--批量打印云卖面单-->
      <Button type="primary" @click="batchPrintBtn('all')"
        v-if="getPermission('ymsContainerGoodsCheck_batchAppendYmsExpressBill')">{{ $t('key1003984') + configCharacters() + $t('key1000616') }}</Button>
    </div>
    <!--列表区域-->
    <div class="table_box mb10" style="padding: 15px 30px">
      <Table
        ref="tableDom"
        highlight-row
        border
        max-height="500"
        :loading="tableLoading"
        :columns="tableColumns"
        @on-selection-change="tableChange"
        :data="tableData">
      </Table>
    </div>
    <!--打印预览YMS面单弹窗-->
    <printPreviewWaybillModal
      :batchPrinting="batchPrinting"
      :maxPrintQuantity="maxPrintQuantity"
      :editablePrint="false"
      ref="printPreviewWaybill"
      @updatePrint="updatePrint"
      :printUrl="printUrl">
    </printPreviewWaybillModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';
import {setConfigCharacters} from "@/utils/common";
import printPreviewWaybillModal from "@/components/common/printPreviewWaybillModal.vue";

export default {
  name: "commodityStickerOperation",
  components: {printPreviewWaybillModal},
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      supplierSku: '',
      tableColumns: [
        {
          type: 'selection',
          width: 70,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000585'),
          key: 'pictureUrl',
          align: 'center',
          minWidth: 120,
          render(h, params) {
            return v.tableImg(h, params, 'primaryImage');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000586'),
          key: 'supplierSku',
          align: 'center'
        },
        {
          title: `${setConfigCharacters(false)}SKU`,
          key: 'ymsSku',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000587'),
          minWidth: 130,
          render(h, params) {
            if (params.row.productGoodsSpecificationList) {
              return h('div', {
                style: {
                  color: 'green'
                }
              }, params.row.productGoodsSpecificationList.map(i => {
                return h('p', i.name + ':' + i.value);
              }));
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003977'),
          key: 'goodProductQuantity',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000318'),
          key: 'printQuantity',
          align: 'center',
          render: (h, params) => {
            return h('InputNumber', {
              props: {
                value: params.row.printQuantity,
                min: 0,
                max: params.row.goodProductQuantity
              },
              style: {
                width: '120px'
              },
              on: {
                input: val => {
                  v.tableData[params.index].printQuantity = val;
                }
              }
            });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          align: 'center',
          width: 160,
          render(h, params) {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000320')}${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000616')}`,
                    show: v.getPermission('ymsContainerGoodsCheck_appendYmsExpressBill'),
                    clickFn: () => {
                      let obj = {
                        ...params.row,
                        quantity: params.row.printQuantity
                      };
                      v.batchPrintBtn('single', obj);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      selectTableData: [],
      printUrl: null,
      batchPrinting: false,
      maxPrintQuantity: null
    };
  },
  mounted() {
    let v = this;
    v.$nextTick(() => {
      v.getFocus('scanning');
    });
  },
  created() {
    this.getList();
  },
  methods: {
    // 回车键扫描供应商SKU
    enterScanInput() {
      let v = this;
      if (v.supplierSku !== '') {
        if (v.tableData.length > 0) {
          let talg = v.tableData.some((item) => {
            return v.supplierSku === item.supplierSku;
          });
          if (talg) {
            for (let i = 0; i < v.tableData.length; i++) {
              let item = v.tableData[i];
              if (v.supplierSku === item.supplierSku) {
                item.printQuantity += 1;
                v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003978'));
                return false;
              }
            }
          } else {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003979'));
            return false;
          }
        }
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003980'));
        return false;
      }
    },

    // 获取列表数据
    getList() {
      let v = this;
      let code = v.$route.query.code;
      let ymsProductGoodsIds = [];
      v.axios.get(api.get_ymsContainerStatus_startChangeOrder + `?code=${code}`).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            let arr = data.ymsContainerGoodsCheckList;
            if (arr) {
              (async () => {
                arr.map((ele) => {
                  ymsProductGoodsIds.push(ele.ymsProductGoodsId);
                });
                if (ymsProductGoodsIds.length > 0) {
                  let list = await v.getProductInfoByIds(ymsProductGoodsIds, arr);
                  if (list) {
                    list.map((item) => {
                      item.printQuantity = 0;
                      item.ymsSku = item._productInfo.ymsSku;
                      item.supplierSku = item._productInfo.supplierSku;
                      item.primaryImage = item._productInfo.primaryImage;
                      item.productGoodsSpecificationList = item._productInfo.productGoodsSpecificationList;
                    });
                    v.tableData = list;
                  }
                } else {
                  v.tableData = arr;
                }
              })();
            }
          }
        }
      });
    },

    // 勾选列表数据
    tableChange(data) {
      this.selectTableData = data || [];
    },

    // 单个、批量打印云卖面单
    batchPrintBtn(type, data) {
      let v = this;
      let url = '';
      let query = '';
      let obj = null;
      // 批量打印
      if (type === 'all') {
        this.batchPrinting = true;
        url = api.post_ymsContainerGoodsCheck_batchAppendYmsExpressBill;
        if (v.selectTableData.length > 0) {
          query = v.selectTableData;
          obj = v.selectTableData[0];
        } else {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003981'));
          return false;
        }
      }
      // 单个打印
      else {
        url = api.post_ymsContainerGoodsCheck_appendYmsExpressBill;
        query = [data];
        this.batchPrinting = false;
        this.maxPrintQuantity = data.goodProductQuantity;
        obj = data;
      }
      this.printUrl = url;
      let talg = false;
      if (query) {
        talg = query.every((item) => {
          return item.quantity !== 0 && item.quantity !== '';
        });
      }
      if (talg) {
        v.$refs['printPreviewWaybill'].initPrintPreviewWaybillData(obj, v.selectTableData);
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003982'));
        return false;
      }
    },
    // 更新
    updatePrint() {
      this.selectTableData = [];
      this.$refs['tableDom'].selectAll(false);
    },
    // 结束贴单作业
    endLabelingBtn() {
      let v = this;
      let code = v.$route.query.code;
      v.axios.get(api.get_ymsContainerStatus_endChangeOrder + `?code=${code}`).then(response => {
        if (response.data.code === 0) {
          v.$router.push('/commoditySticker');
        }
      });
    },
  }
};
</script>

<style lang="less" scoped>
.commodityStickerOperation_box {
  width: 100%;
  height: 100vh;
  background-color: #f5f7f9;

  .scanning_header_box {
    padding: 0 30px;
    height: 60px;
    background-color: #fff;

    .title {
      font-weight: bold;
      font-size: 18px;
      color: #5BB1FF;
    }
  }

  .scanning_box {
    padding: 20px 30px;
    background-color: #fff;

    .input_styles {
      width: 350px;

      .title {
        color: #333;
        font-weight: bold;
        font-size: 15px;
        margin-bottom: 2px;
      }

      /deep/ .ivu-input-large::-webkit-input-placeholder {
        color: #C5C8CE;
        font-size: 15px;
      }

      /deep/ .ivu-input-large:-moz-placeholder {
        color: #C5C8CE;
        font-size: 15px;
      }

      /deep/ .ivu-input-large::-moz-placeholder {
        color: #C5C8CE;
        font-size: 15px;
      }

      /deep/ .ivu-input-large:-ms-input-placeholder {
        color: #C5C8CE;
        font-size: 15px;
      }

      /deep/ .ivu-input-large {
        height: 44px;
        font-size: 16px;
        color: #666;
      }

      /deep/ .ivu-input-prefix i {
        line-height: 44px;
      }

      /deep/ .ivu-icon-icon-scan:before {
        font-size: 25px;
      }
    }

  }

  .table_box {
    background-color: #fff;
  }
}
</style>
